import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export const StModalContainerWithModal = styled(Box)(({ theme }) => ({
  padding: 0,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '16px',
  maxWidth: '617px',
  background: theme.palette.white.main,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  '&:before': {
    content: '""',
    display: 'block',
    background: 'linear-gradient(1.33deg, #005587 -2.85%, #00beb1 144.31%)',
    height: '16px',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
  },
  '&:focus': {
    outline: '0 !important',
  },
  '.MuiIconButton-root': {
    marginTop: '-3px',
  },
  [theme.breakpoints.down(670)]: {
    width: '332px',
  },
}));

export const StmodalContainer = styled(Box)(() => ({
  padding: '24px',
}));

export const StHeadingContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StHeadingText = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '20px',
  color: '#000000',
}));

export const StDescriptionText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: theme.palette.text.primary,
  margin: '28px 0 32px',
}));

export const StFooterbuttons = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  a: {
    padding: '12px 22px',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '16px',
    minWidth: '110px',
    marginLeft: '32px',
    wordWrap: 'break-word',
  },
  button: {
    display: 'inline-block',
    wordWrap: 'break-word',
  },
}));
